class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();

      if (this.dataset.promoProduct) {
        sessionStorage.setItem("p_gwp", this.dataset.sessionId);
      }
      this.closest("cart-items").updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

let customerLocation = "";
$.ajax({
  url: "https://geolocation-db.com/json/",
  jsonpCallback: "callback",
  dataType: "json",
  success: function (location) {
    customerLocation = location.country_code;
  },
});

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById(
      "shopping-cart-line-item-status",
    );
    this.cartErrors = document.getElementById("cart-errors");

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]'),
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0,
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));

    var _this = this;
    window.addEventListener("resize", _this.fixFormHeight.bind(_this));

    let popUp = document.querySelector(".pop-up__promo-gwp");
    if (
      popUp &&
      sessionStorage.getItem("gwp") != "open" &&
      sessionStorage.getItem("gwp") != "close"
    ) {
      _this.getCartBeforePromo();
    }

    this.checkGiftsInCart();

    if ($(".drawer--cart__bar-us").length > 0) {
      if (customerLocation == "US") {
        $(".drawer--cart__bar-us").css("display", "block");
      } else {
        $(".drawer--cart__bar-us").css("display", "none");
      }
    }
  }

  onChange(event) {
    if (event.target === null) return;
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name"),
    );
  }

  checkGiftsInCart() {
    let _this = this,
      gift,
      gift_line,
      promo_buyX_getY_gift_line,
      gift_qty,
      gift_count = 0,
      has_gift = false,
      product_with_gift = false,
      has_promo_buyX_getY = false,
      promo_buyX_getY_trigger = false,
      promo_gwp_trigger = false;

    fetch("/cart.json")
      .then((response) => response.json())
      .then((cart) => {
        cart.items.forEach(function (cartItem, i) {
          var line_number = i + 1;
          if (cartItem.properties && cartItem.properties["_product-type"]) {
            if (cartItem.properties["_product-type"] == "product_with_gift") {
              product_with_gift = true;
            }
            if (cartItem.properties["_product-type"] == "gift") {
              gift = cartItem;
              gift_line = line_number;
              has_gift = true;
            }
            // if (cartItem.properties['_product-type'] == 'gift buyX getY') {
            //   promo_buyX_getY_gift_line = line_number;
            //   has_promo_buyX_getY = true;
            // }
          }

          if (
            window.promo_buyX_getY &&
            cartItem.product_id == window.promo_buyX_getY.mainProductTrigger
          ) {
            promo_buyX_getY_trigger = true;
          }
        });

        if (!product_with_gift && !promo_buyX_getY_trigger && has_gift) {
          _this.updateQuantity(
            gift_line,
            0,
            document.activeElement.getAttribute("name"),
          );
        }

        // if (!promo_buyX_getY_trigger && has_promo_buyX_getY) {
        //   _this.updateQuantity(promo_buyX_getY_gift_line, 0, document.activeElement.getAttribute('name'));
        // }
      });
  }

  getCartBeforePromo() {
    let _this = this;
    fetch("/cart.json")
      .then((response) => response.json())
      .then((cart) => {
        _this.promoGWP(cart);
      });
  }

  promoGWP(parsedState) {
    let _this = this;
    let cartTotal = window.promo_gwp.priceBeforeDiscount
      ? (parsedState.original_total_price / 100).toFixed(2)
      : (parsedState.total_price / 100).toFixed(2);
    if (cartTotal < 1) {
      sessionStorage.setItem("gwp", "");
      // return
    }

    let cartItems = parsedState.items;
    let popUp = document.querySelector(".pop-up__promo-gwp");

    if (popUp) {
      const promo_min_sum = popUp.getAttribute("data-min-sum") * 1;
      const promoStart =
        new Date(popUp.getAttribute("data-start")).getTime() +
        popUp.getAttribute("data-time-zone") * 60 * 1000;
      const promoFinish =
        new Date(popUp.getAttribute("data-finish")).getTime() +
        popUp.getAttribute("data-time-zone") * 60 * 1000;
      const customer_time =
        new Date().getTimezoneOffset() * 60 * 1000 + Date.now();

      let popUp_time =
        promoStart < customer_time && customer_time < promoFinish
          ? true
          : false;
      let popUp_sum = cartTotal >= promo_min_sum ? true : false;
      let gift_in_cart = false;
      let update_cart = false;

      cartItems.forEach(function (item, index) {
        if (
          item.properties &&
          item.properties["_product-type"] == "gift_promo_gwp"
        ) {
          gift_in_cart = index + 1;
        }
      });

      if (
        popUp_time &&
        popUp_sum &&
        !gift_in_cart &&
        sessionStorage.getItem("gwp") != "close"
      ) {
        popUp.classList.remove("hidden");
        document.querySelector("body").classList.add("show-pop-up");
        sessionStorage.setItem("gwp", "open");
      } else if ((!popUp_time || !popUp_sum) && gift_in_cart) {
        update_cart = true;
      } else {
        window.promo.closePopUp();
        sessionStorage.setItem("gwp", "");
      }

      if (update_cart) {
        this.updateQuantity(
          gift_in_cart,
          0,
          document.activeElement.getAttribute("name"),
        );
      }
    }

    if (window.promo_gwp) {
      this.checkoutButtons = document.querySelectorAll(
        ".mini-cart__footer button",
      );

      const promoStart =
        new Date(window.promo_gwp.dataStart).getTime() +
        window.promo_gwp.timeZone * 60 * 1000;
      const promoFinish =
        new Date(window.promo_gwp.dataEnd).getTime() +
        window.promo_gwp.timeZone * 60 * 1000;
      const customer_time =
        new Date().getTimezoneOffset() * 60 * 1000 + Date.now();

      let promo_min_sum = parseInt(window.promo_gwp.priceTrigger);
      let total_more_than_min = parseInt(cartTotal) >= promo_min_sum;

      let promo_gwp_in_cart = false;
      let gift_discounted = false;
      let gift_line;
      let session_gift = sessionStorage.getItem("p_gwp");

      if (!total_more_than_min) {
        sessionStorage.setItem("p_gwp", "");
      }

      cartItems.forEach(function (item, index) {
        if (
          item.properties &&
          item.properties["_product-type"] == "gift_promo_gwp"
        ) {
          promo_gwp_in_cart = true;
          gift_line = index + 1;

          if (item.total_discount == 0) {
            gift_discounted = false;
          } else {
            gift_discounted = true;
          }
        }
      });

      if (session_gift) {
        if (session_gift.indexOf(window.promo_gwp.productGift) > -1) {
          promo_gwp_in_cart = true;
        }
      }

      if (
        !promo_gwp_in_cart &&
        window.promo_gwp.productGift &&
        total_more_than_min &&
        promoStart < customer_time &&
        customer_time < promoFinish
      ) {
        const sections = this.getSectionsToRender().map(
          (section) => section.section,
        );

        const body = JSON.stringify({
          items: [
            {
              id: window.promo_gwp.productGift,
              quantity: 1,
              properties: {
                "_product-type": "gift_promo_gwp",
              },
            },
          ],
          sections: sections,
          sections_url: window.location.pathname,
        });

        this.checkoutButtons.forEach(function (item, i) {
          item.classList.add("loading");
        });

        fetch(`${routes.cart_add_url}`, { ...fetchConfig("javascript"), body })
          // .then((response) => response.json())
          .then((response) => {
            if (_this.classList.contains("cart-page-template")) {
              window.location.reload();
            } else {
              return response.json();
            }
          })
          .then((parsedState) => {
            _this.fixFormHeight();
            _this.renderContents(parsedState);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.checkoutButtons.forEach(function (item, i) {
              item.classList.remove("loading");
            });
          });
      } else if (
        (promo_gwp_in_cart && !total_more_than_min) ||
        (promo_gwp_in_cart && customer_time < promoStart) ||
        (promo_gwp_in_cart && customer_time > promoFinish)
      ) {
        this.updateQuantity(
          gift_line,
          0,
          document.activeElement.getAttribute("name"),
        );
      }
    }
  }

  getSectionsToRender() {
    let sections = [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items")?.dataset.id,
        selector: ".js-contents",
      },
      {
        id: "mini-cart",
        section: "mini-cart",
        selector: ".shopify-section",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer")?.dataset.id,
        selector: ".js-contents",
      },
    ];
    if (document.querySelector("#main-cart-footer .free-shipping")) {
      sections.push({
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer")?.dataset.id,
        selector: ".free-shipping",
      });
    }
    return sections;
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);
    const sections = this.getSectionsToRender().map(
      (section) => section.section,
    );

    const body = JSON.stringify({
      line,
      quantity,
      sections: sections,
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const element = document.getElementById(section.id);
          if (element) {
            const elementToReplace =
              element.querySelector(section.selector) || element;

            if (elementToReplace && parsedState.sections[section.section]) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector,
              );
            }
          }
        });

        // Update cart count bubbles
        const cartCountBubbles = document.querySelectorAll(".js-cart-count-bubble");
        const totalItems = document.querySelectorAll('.js-mini-cart-item')
        for (const bubble of cartCountBubbles) {
          const bubbleAmount = bubble.querySelector(".js-cart-count-bubble-amount");
          if (totalItems && totalItems.length > 0) {
            bubble.classList.remove("visually-hidden");
            let totalItemsCount = 0;
            totalItems.forEach((item) => {
              const itemQuantity = parseInt(item.querySelector('[name="updates[]"]').value);
              if (!isNaN(itemQuantity)) {
                totalItemsCount += itemQuantity;
              }
            });
            bubbleAmount.innerText = totalItemsCount;
          } else {
            bubble.classList.add("visually-hidden");
            bubbleAmount.innerText = 0;
          }
        }

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && name)
          lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();

        this.checkGiftsInCart();
        this.promoGWP(parsedState);
        this.fixFormHeight();
      })
      .catch(() => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden"),
        );
        this.disableLoading();
        if (this.cartErrors) {
          this.cartErrors.textContent = cartStrings.error;
        }
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const quantityError = document.getElementById(`Line-item-error-${line}`);
      if (quantityError) {
        quantityError.querySelector(".cart-item__error-text").innerHTML =
          cartStrings.quantityError.replace(
            "[quantity]",
            document.getElementById(`Quantity-${line}`).value,
          );
      }
    }

    this.currentItemCount = itemCount;

    if (this.lineItemStatusElement)
      this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus = document.getElementById("cart-live-region-text");
    if (cartStatus) {
      cartStatus.setAttribute("aria-hidden", false);

      setTimeout(() => {
        cartStatus.setAttribute("aria-hidden", true);
      }, 1e3);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector)?.innerHTML;
  }

  fixFormHeight() {
    setTimeout(function () {
      var miniCart = document.querySelector("form.mini-cart");
      var miniCartInner = document.querySelector(".mini-cart__inner");

      if (miniCart) {
        if (miniCartInner.offsetHeight > miniCart.offsetHeight) {
          miniCart.classList.add("min-height");
        } else {
          miniCart.classList.remove("min-height");
        }
      }
    }, 10);
  }

  enableLoading(line) {
    const cartItems = document.getElementById("main-cart-items");
    if (cartItems) cartItems.classList.add("cart__items--disabled");

    const loadingOverlay = this.querySelectorAll(".loading-overlay")[line - 1];
    if (loadingOverlay) loadingOverlay.classList.remove("hidden");

    document.activeElement.blur();
    if (this.lineItemStatusElement)
      this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading() {
    const cartItems = document.getElementById("main-cart-items");
    if (cartItems) {
      cartItems.classList.remove("cart__items--disabled");
    }
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      const element = document.getElementById(section.id);
      // console.log(element, parsedState.sections[section.id]);

      if (element) {
        element.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector,
        );
      }
    });

    var miniCart = document.querySelector(".mini-cart");
    var miniCartInner = document.querySelector(".mini-cart__inner");

    /*console.log(miniCartInner.offsetHeight);
    console.log(miniCart.offsetHeight);*/

    if (miniCartInner.offsetHeight < miniCart.offsetHeight) {
      miniCart.classList.add("min-height");
    } else {
      miniCart.classList.remove("min-height");
    }
  }
}
customElements.define("cart-items", CartItems);

class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "change",
      debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300),
    );
  }
}
customElements.define("cart-note", CartNote);

class DiscountCode extends HTMLElement {
  constructor() {
    super();

    if (isStorageSupported("session")) {
      this.setupDiscount();

      this.addEventListener("change", (event) => {
        window.sessionStorage.setItem("discount", event.target.value);
      });
    }
  }

  setupDiscount() {
    const discount = window.sessionStorage.getItem("discount");
    if (discount !== null) {
      this.querySelector('input[name="discount"]').value = discount;
    }
  }
}

customElements.define("discount-code", DiscountCode);

class ShippingCalculator extends HTMLElement {
  constructor() {
    super();

    this.setupCountries();

    this.errors = this.querySelector("#ShippingCalculatorErrors");
    this.success = this.querySelector("#ShippingCalculatorSuccess");
    this.zip = this.querySelector("#ShippingCalculatorZip");
    this.country = this.querySelector("#ShippingCalculatorCountry");
    this.province = this.querySelector("#ShippingCalculatorProvince");
    this.button = this.querySelector("button");
    this.button.addEventListener("click", this.onSubmitHandler.bind(this));
  }

  setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(
        "ShippingCalculatorCountry",
        "ShippingCalculatorProvince",
        {
          hideElement: "ShippingCalculatorProvinceContainer",
        },
      );
    }
  }

  onSubmitHandler(event) {
    event.preventDefault();

    this.errors.classList.add("hidden");
    this.success.classList.add("hidden");
    this.zip.classList.remove("invalid");
    this.country.classList.remove("invalid");
    this.province.classList.remove("invalid");
    this.button.classList.add("loading");
    this.button.setAttribute("disabled", true);

    const body = JSON.stringify({
      shipping_address: {
        zip: this.zip.value,
        country: this.country.value,
        province: this.province.value,
      },
    });
    let sectionUrl = `${routes.cart_url}/shipping_rates.json`;

    // remove double `/` in case shop might have /en or language in URL
    sectionUrl = sectionUrl.replace("//", "/");

    fetch(sectionUrl, { ...fetchConfig("javascript"), body })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.shipping_rates) {
          this.success.classList.remove("hidden");
          this.success.innerHTML = "";

          parsedState.shipping_rates.forEach((rate) => {
            const child = document.createElement("p");
            child.innerHTML = `${rate.name}: ${rate.price} ${Shopify.currency.active}`;
            this.success.appendChild(child);
          });
        } else {
          let errors = [];
          Object.entries(parsedState).forEach(([attribute, messages]) => {
            errors.push(
              `${attribute.charAt(0).toUpperCase() + attribute.slice(1)} ${messages[0]}`,
            );
          });

          this.errors.classList.remove("hidden");
          this.errors.querySelector(".errors").innerHTML = errors.join("; ");
        }
      })
      .catch((e) => {
        /*console.error(e);*/
      })
      .finally(() => {
        this.button.classList.remove("loading");
        this.button.removeAttribute("disabled");
      });
  }
}

customElements.define("shipping-calculator", ShippingCalculator);

class addProductWithGiftToCart extends HTMLElement {
  constructor() {
    super();

    this.miniCart = document.querySelector("mini-cart");
    this.cartItems = this.miniCart.querySelector("cart-items");
    this.checkoutButtons = document.querySelectorAll(
      ".mini-cart__footer button",
    );

    var buttonAddProductWithGift = this.querySelector("button");
    buttonAddProductWithGift.addEventListener("click", (event) => {
      event.preventDefault();
      this.addToCart(buttonAddProductWithGift);
    });
  }

  addToCart(btn) {
    btn.setAttribute("disabled", true);
    this.checkoutButtons.forEach(function (item, i) {
      item.classList.add("loading");
    });

    const sections = this.miniCart
      ? this.miniCart.getSectionsToRender().map((section) => section.id)
      : [];

    const body = JSON.stringify({
      items: [
        {
          id: btn.getAttribute("data-main-product"),
          quantity: 1,
          properties: {
            "_product-type": "product_with_gift",
          },
        },
        {
          id: btn.getAttribute("data-gift"),
          quantity: 1,
          properties: {
            "_product-type": "gift",
          },
        },
      ],
      sections: sections,
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig("javascript"), body })
      .then((response) => response.json())
      .then((parsedState) => {
        this.cartItems.fixFormHeight();
        this.cartItems && this.cartItems.renderContents(parsedState);
      })
      .catch((e) => {
        /*console.error(e);*/
      })
      .finally(() => {
        btn.removeAttribute("disabled", true);
        this.checkoutButtons.forEach(function (item, i) {
          item.classList.remove("loading");
        });
      });
  }
}

customElements.define("mini-cart-product-with-gift", addProductWithGiftToCart);

class addSampleToCart extends HTMLElement {
  constructor() {
    super();

    this.miniCart = document.querySelector("mini-cart");
    this.cartItems = this.miniCart.querySelector("cart-items");
    this.checkoutButtons = document.querySelectorAll(
      ".mini-cart__footer button",
    );

    var _this = this;

    var buttonAddSample = this.querySelectorAll("button");
    buttonAddSample.forEach(function (item, i) {
      item.addEventListener("click", (event) => {
        event.preventDefault();
        _this.addToCart(item);
      });
    });
  }

  addToCart(btn) {
    btn.setAttribute("disabled", true);
    this.checkoutButtons.forEach(function (item, i) {
      item.classList.add("loading");
    });

    const sections = this.miniCart
      ? this.miniCart.getSectionsToRender().map((section) => section.id)
      : [];

    const body = JSON.stringify({
      items: [
        {
          id: btn.getAttribute("data-sample-id"),
          quantity: 1,
          properties: {
            "_product-type": "free-sample",
          },
        },
      ],
      sections: sections,
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig("javascript"), body })
      .then((response) => response.json())
      .then((parsedState) => {
        this.cartItems.fixFormHeight();
        this.cartItems && this.cartItems.renderContents(parsedState);
      })
      .catch((e) => {
        /*console.error(e);*/
      })
      .finally(() => {
        btn.removeAttribute("disabled", true);
        this.checkoutButtons.forEach(function (item, i) {
          item.classList.remove("loading");
        });
      });
  }
}

customElements.define("mini-cart-samples", addSampleToCart);
